import { useStore } from 'vuex';
import createButtonVariables from './create-button-variables';

export const generateStylingVariables = (style, specificKey = '') => {
    const variables = {};

    for (const [componentKey, component] of Object.entries(style)) {
        if (!component._info || !component._info.hasOwnProperty('editor-type') || (component.use && !component.use.value)) continue;
        if (component['_info']['editor-type'] !== 'StyleSection') continue;

        for (const [key, input] of Object.entries(component)) {
            if (specificKey !== '' && componentKey !== specificKey) continue;

            if (componentKey !== 'container') {
                if (input['editor-type'] === 'StyleSection') continue;
                if (input['editor-type'] === 'CheckboxInput') continue;

                variables[`--${componentKey}-${key}`] = input.value;
            }

            if (componentKey === 'container') {
                variables[`--${componentKey}-shadow`] = component.style.shadow.value;
                variables[`--${componentKey}-shadow-offset-y`] = `var(--container-shadow-offset-y--${component.shadow.value ? 'on' : 'off'})`;
                variables[`--${componentKey}-shadow-blur-radius`] = `var(--container-shadow-blur-radius--${component.shadow.value ? 'on' : 'off'})`;
                variables[`--${componentKey}-border`] = `var(--container-border-width--${component.border.value})`;
                variables[`--${componentKey}-border-color`] = component.style.border.value;
                variables[`--${componentKey}-border-shape`] = `var(--container-shape--${component.shape.value})`;
            }
        }
    }

    return variables;
};

export const addTypography = options => {
    const store = useStore();
    const keys = Object.keys(options);

    Object.values(options).forEach((option, index) => {
        store.commit('styling/addTypography', { key: keys[index], option });
    });
};

export const addButtonStyling = buttons => {
    const store = useStore();

    buttons.forEach(button => {
        store.commit('styling/addButtonStyling', { key: button.uuid, button });
    });
};

export const generateButtonVariables = placement => {
    const store = useStore();
    let button;

    for (const value of Object.values(store.state.styling.buttons)) {
        if (value.placement.value.includes(placement)) {
            button = value;
            break;
        }
    }

    if (!button) {
        for (const value of Object.values(store.state.styling.buttons)) {
            if (value.placement.value.includes('all')) {
                button = value;
                break;
            } else {
                button = Object.values(store.state.styling.buttons)[0];
            }
        }
    }

    return createButtonVariables(button);
};

export const generateIndividualButtonVariables = answer => {
    const store = useStore();

    if (!answer.button_style) return;
    if (answer.button_style?.value === '') return;

    const uuid = answer.button_style.value;
    let button;

    if (store.state.styling.buttons[uuid]) {
        button = store.state.styling.buttons[uuid];
    } else {
        return;
    }

    return createButtonVariables(button);
};

export const addInputStyling = formFields => {
    const store = useStore();

    formFields.forEach(input => {
        const keys = input.placement.value;

        keys.forEach(key => {
            store.commit('styling/addInputStyling', { key: key, input });
        });
    });
};

export const generateInputVariables = key => {
    const store = useStore();
    let input = store.state.styling.inputs[key];

    if (!input) input = store.state.styling.inputs['all'] || Object.values(store.state.styling.inputs)[0];

    const buttonTypes = ['regular', 'small'];

    const variables = {
        '--input-background': input.style.background.value,
        '--input-shadow': input.style.shadow.value,
        '--input-border': input.style.border.value,
        '--input-arrow-color': input.style.arrow.value,
        '--input-floating-label': input.style.floatingLabel?.value,
    };

    for (const type of buttonTypes) {
        variables[`--${type}-input-border-shape`] = `var(--${type}-input-shape--${input.shape.value})`;
        variables[`--${type}-input-shadow-size`] = `var(--${type}-input-shadow-size--${input.shadow.value ? 'on' : 'off'})`;
        variables[`--${type}-input-border-width`] = `var(--${type}-input-border-width--${input.border.value})`;
    }

    return variables;
};

export const addContainerStyling = containers => {
    const store = useStore();

    containers.forEach(container => {
        const keys = container.placement.value;

        keys.forEach(key => {
            store.commit('styling/addContainerStyling', { key: key, container });
        });
    });
};

export const generateContainerVariables = key => {
    const store = useStore();
    let container = store.state.styling.containers[key];

    if (!container) container = store.state.styling.containers['all'] || Object.values(store.state.styling.containers)[0];

    return {
        '--container-shadow': container.style.shadow.value,
        '--container-shadow-offset-y': `var(--container-shadow-offset-y--${container.shadow.value ? 'on' : 'off'})`,
        '--container-shadow-blur-radius': `var(--container-shadow-blur-radius--${container.shadow.value ? 'on' : 'off'})`,
        '--container-border': `var(--container-border-width--${container.border.value})`,
        '--container-border-color': container.style.border.value,
        '--container-border-shape': `var(--container-shape--${container.shape.value})`,
    };
};
